import React from 'react'
// ##
import DistributorsTable from '../../modules/Distributor/components/DistributorsTable'

export default function DistributorPage() {
  return <DistributorsTable />
}
